import React, { useState, useEffect } from "react";
import "./HomePage.scss";
import { Link } from "react-router-dom";

const HomePage = () => {
  const [showSecondImage, setShowSecondImage] = useState(false);

  useEffect(() => {
    // Después de 10 segundos, establece showSecondImage en true
    const timer = setTimeout(() => {
      setShowSecondImage(true);
    }, 10000);

    // Limpia el temporizador cuando el componente se desmonta
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`fondo ${showSecondImage ? "showSecondImage" : ""}`}>
      <Link className="homeLink" to={"/fashion"}>
        <img src="./titulo.png" alt="titulo" className="tituloPortada"></img>
      </Link>
      <div className="galleryContainer">
        {/* Aquí puedes agregar tu galería de imágenes */}
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_wan01.jpg?v=1"
          alt="mauro-testa_fotografiademoda__fotografo_wan01"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_maral02.jpg?v=1"
          alt="mauro-testa_fotografiademoda__fotografo_maral02"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_moon03.jpg?v=1"
          alt="mauro-testa_fotografiademoda__fotografo_moon03"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_moon06.jpg?v=1"
          alt="mauro-testa_fotografiademoda__fotografo_moon06"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_maral01.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_maral01"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_cy03.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_cy03"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_bf01.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_bf01"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_moon02.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_moon02"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_luis01.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_luis01"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_maral07.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_maral07"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_yatu01.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_yatu01"
          className="galleryImage"
        />
        <img
          src="./fashion/mauro-testa_fotografiademoda__fotografo_cy07.jpg?v=1"
          alt="./fashion/mauro-testa_fotografiademoda__fotografo_cy07"
          className="galleryImage"
        />
        {/* Agrega más imágenes según sea necesario */}
      </div>
      {/* Palabras clave ocultas */}
      <h1 style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        Fotografo de moda, fotografo, artista, fashion photographer, artist,
        madrid, Mauro Testa
        {/* Agrega más palabras clave ocultas según sea necesario */}
      </h1>
    </div>
  );
};

export default HomePage;

{
  /* <img
        src="./busto.png"
        alt="segunda_imagen"
        className={`segundaImagen ${
          showSecondImage ? "showSecondImage" : ""
        }`}
      ></img> */
}
